import { withConsentPilot } from "../utils/consent";
import { useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { UPSELL_V2_ENABLED } from "../constants/upsellsV2";
import { getClientReferenceId } from "../utils/amplitude";
import { upsellV2Session } from "../utils/upsellV2Session";

// Both card and wallet success callbacks use the currency charged by their paywall.
// Keep the existing fallback callback intact for rollout and excluded routes.
export function useUpsellV2Entry({
  currency,
  onLegacySuccess,
  excluded = false,
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const completedRoute = useRef(null);
  return () => {
    if (completedRoute.current === location.key) return;
    completedRoute.current = location.key;
    const target = upsellV2Session.start({
      enabled: UPSELL_V2_ENABLED && !excluded,
      pathname: location.pathname,
      search: location.search,
      currency,
      clientReferenceId: getClientReferenceId(),
      legacyTarget: null,
    });
    if (!target) onLegacySuccess();
    else if (target.startsWith("/") && !target.startsWith("//"))
      navigate(withConsentPilot(target));
    else window.location.href = withConsentPilot(target);
  };
}
